export default __webpack_public_path__ + "static/media/codeship.8bffb623.svg";